/* eslint-disable import/prefer-default-export */
import { axiosWCApiInstance } from '../Configurations/AxiosConfiguration';

export const getInvoicePdf = async (invoiceId) => {
    try {
        if (invoiceId <= 0) {
            throw new Error('Invalid invoiceId parameter');
        }

        const url = `invoice/${invoiceId}/pdf`;
        const response = await axiosWCApiInstance.get(url);

        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return [];
        }
        console.error(error);
        throw error;
    }
};
